// extracted by mini-css-extract-plugin
export default {"row":"aB6Is5aUGpomM22ZBt0P"};